import { stringify } from "query-string"
import { farasod } from "./api"

const endpoint = "/shift"

export const addShift = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const editShift = async (shiftId, data) => {
  const response = await farasod.patch(`${endpoint}/${shiftId}`, data)

  return response.data
}

export const deleteShift = async shiftId => {
  const response = await farasod.post(`${endpoint}/${shiftId}`)

  return response.data
}

export const getShifts = async (queries) => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const getShift = async (shiftId) => {
  const response = await farasod.get(`${endpoint}/${shiftId}`)

  return response.data
}

export const forceCloseShift = async (shiftId) => {
  const response = await farasod.patch(`${endpoint}/force/close/${shiftId}`)

  return response.data
}